import { type Components } from "@mui/material/styles";

export const formControl: Components["MuiFormControl"] = {
  defaultProps: {
    size: "small",
  },
};
